import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { speedCoachingProfileSchema } from '../schemas/speed-coaching-profile.schema';

/**
 * Returns the default Speed Coaching Profile
 * @returns The default Speed Coaching Profile
 */
export function getSpeedCoachingDefault(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).speedCoachingDefaultUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(speedCoachingProfileSchema));
}
